import { render, staticRenderFns } from "./DhmeWkbRisksLibrary.vue?vue&type=template&id=e9ab0626&scoped=true"
import script from "./DhmeWkbRisksLibrary.vue?vue&type=script&lang=js"
export * from "./DhmeWkbRisksLibrary.vue?vue&type=script&lang=js"
import style0 from "./DhmeWkbRisksLibrary.vue?vue&type=style&index=0&id=e9ab0626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ab0626",
  null
  
)

export default component.exports